import api from '../config/api';
import { User } from '../types';

export const authService = {
  register: async (data: { email: string; username: string; password: string; display_name?: string }): Promise<User> => {
    const res = await api.post('/api/auth/register', data);
    return res.data;
  },

  login: async (data: { email: string; password: string }): Promise<{ access_token: string; token_type: string }> => {
    const res = await api.post('/api/auth/login', data);
    return res.data;
  },

  getMe: async (): Promise<User> => {
    const res = await api.get('/api/auth/me');
    return res.data;
  },

  updateProfile: async (data: { display_name?: string; username?: string; game_preferences?: number[] }): Promise<User> => {
    const res = await api.put('/api/users/me', data);
    return res.data;
  },
};
